export enum FORM_NAME {
  CREATE_SURVEY_HEALTH = 'CREATE_SURVEY_HEALTH',
  UPDATE_SURVEY_HEALTH = 'UPDATE_SURVEY_HEALTH',
}
